<div class="auth-wrapper auth-v2">
  <div class="auth-inner row m-0">
    <!-- Brand logo--><a class="brand-logo" href="javascript:void(0);">
      <img src="{{ coreConfig.app.appLogoImage }}" alt="brand-logo" height="28" />
      <h2 class="brand-text text-primary ml-1">{{ coreConfig.app.appName }}</h2>
    </a>
    <!-- /Brand logo-->
    <!-- Left Text-->
    <div class="d-none d-lg-flex col-lg-8 align-items-center p-5">
      <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
        <img class="img-fluid" [src]="
            coreConfig.layout.skin === 'dark'
              ? 'assets/images/pages/register-v2-dark.svg'
              : 'assets/images/pages/register-v2.svg'
          " alt="Register V2" />
      </div>
    </div>
    <!-- /Left Text-->
    <!-- Register-->
    <div class="d-flex col-lg-4 align-items-center auth-bg px-2 p-lg-5">
      <div class="col-12 col-sm-8 col-md-6 col-lg-12 px-xl-2 mx-auto">
        <h2 class="card-title font-weight-bold mb-1">
          La aventura comienza aquí 🚀.
        </h2>
        <p class="card-text mb-2">
          Haz que la gestión de tus proyectos sea eficaz y fácil.
        </p>
        <form class="auth-register-form mt-2" [formGroup]="registerForm" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="register-id" class="form-label">Identificador de usuario (ID)</label>
            <input type="text" formControlName="id" class="form-control" placeholder="xxxxxxxxxxxxxxxxxxxxxxxx"
              aria-describedby="register-id" tabindex="2" [ngClass]="{ 'is-invalid': submitted && f.id.errors }" />
            <div *ngIf="submitted && f.id.errors" class="invalid-feedback">
              <div *ngIf="f.id.errors.required">
                Se requiere el identificador de usuario
              </div>
              <div *ngIf="f.id.errors.objectID">
                El identificador de usuario no es válido, compruebe
              </div>
            </div>
          </div>

          <div class="form-group">
            <label for="register-password" class="form-label">Contraseña temporal</label>

            <div class="input-group input-group-merge form-password-toggle">
              <input [type]="passwordTextType ? 'text' : 'password'" formControlName="password"
                class="form-control form-control-merge" placeholder="······················"
                aria-describedby="register-password" tabindex="3" [ngClass]="{
                  'is-invalid error': submitted && f.password.errors
                }" />
              <div class="input-group-append">
                <span class="input-group-text cursor-pointer"><i class="feather font-small-4" [ngClass]="{
                      'icon-eye-off': passwordTextType,
                      'icon-eye': !passwordTextType
                    }" (click)="togglePasswordTextType()"></i></span>
              </div>
            </div>
            <div *ngIf="submitted && f.password.errors" class="invalid-feedback"
              [ngClass]="{ 'd-block': submitted && f.password.errors }">
              <div *ngIf="f.password.errors.required">
                Se require la contraseña
              </div>
              <div *ngIf="
                  f.password.errors.minlength || f.password.errors.maxlength
                ">
                La contraseña temporal debe tener 22 caracteres
              </div>
            </div>
          </div>
          <div class="form-group">
            <div class="custom-control custom-checkbox">
              <input class="custom-control-input" type="checkbox" formControlName="privacyPolicyTerms"
                id="register-privacy-policy" tabindex="4" />
              <label class="custom-control-label" for="register-privacy-policy">
                Acepto la
                <a [href]="privacyPolicyTerms">política de privacidad y las condiciones</a>
              </label>
            </div>
            <div *ngIf="submitted && f.privacyPolicyTerms.errors" class="invalid-feedback" [ngClass]="{
                'd-block': submitted && f.privacyPolicyTerms.errors
              }">
              <div *ngIf="f.privacyPolicyTerms.errors.required">
                Para usar la aplicación Journey Access App es necesario aceptar la política
                de privacidad y las condiciones
              </div>
            </div>
          </div>
          <button class="btn btn-primary btn-block" tabindex="5" rippleEffect>
            Descargar archivo de acceso
          </button>
        </form>
        <p class="text-center mt-2">
          <span>¿Ya tiene su archivo de acceso?</span><a routerLink="/authentication/login"><span>&nbsp;Inicie sesión en
              su lugar</span></a>
        </p>
      </div>
    </div>
    <!-- /Register-->
  </div>
</div>